import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import moment from 'moment';
import { loginApi } from '@/api/api';
import './index.scss';
import { host } from '@/api/host';

const CodeModal = (props) => {
    const [codeErr, setCodeErr] = useState('');
    const [codeInput, setCodeInput] = useState('');
    const [imgCode, setImgCode] = useState('');
    const title = props.title || "图形验证";
    const notice = props.notice || "";
    const confirmText = props.confirmText || "确认";
    const inputPlaceholder = props.inputPlaceholder || "请输入下图中图形验证码";

    const handleCodeChange = (e) => {
        setCodeInput(e.target.value);
    }

    const hideCodeModal = () => {
        setCodeErr('');
        setCodeInput('');
        props.hideCodeModal();
    }

    const refreshCode = () => {
        const phone = props.phone;
        const imgCodeVal = host + "/user/acquireImageCode?mobile=" + phone + "&time=" + moment().valueOf();
        setImgCode(imgCodeVal);
    }

    useEffect(() => {
        if (props.visible) {
            refreshCode();
        }
    }, [props.visible]);

    const showCode = () => {
        const href = window.location.href;
        let flag = false;
        if (href.indexOf('https://') > -1) {
            // 测试环境
            if (
                href.indexOf('https://test') > -1 &&
                href.indexOf('https://test.') == -1 ||
                href.indexOf('https://localhost') > -1
            ) {
                flag = true;
            } else if ( // dev环境
                href.indexOf('https://dev') > -1 &&
                href.indexOf('https://dev.') == -1
            ) {
                flag = true;
            }
            return flag;
        } else {
            // 测试环境
            if (
                href.indexOf('http://test') > -1 &&
                href.indexOf('http://test.') == -1 ||
                href.indexOf('http://localhost') > -1
            ) {
                flag = true;
            } else if ( // dev环境
                href.indexOf('http://dev') > -1 &&
                href.indexOf('http://dev.') == -1
            ) {
                flag = true;
            }
            return flag;
        }
    }

    const validateCode = () => {
        if (!codeInput) {
            setCodeErr('请输入图形验证码');
            return;
        }

        const params = {
            mobile: props.phone,
            code: codeInput,
            needSupportFsd: props.needSupportFsd || 0,
        };

        if (showCode()) {
            params.id = 999;
        }

        loginApi
            .sendSms(params)
            .then((res) => {
                if (props.callBack) props.callBack(res && res.selectedAgree ? res.selectedAgree : 0);
                hideCodeModal();
            })
            .catch((err) => {
                if (!err.cancel) {
                    setCodeErr(err);
                }
            });
    }

    return (
        <Modal
            className="code-modal"
            destroyOnClose
            footer={null}
            getContainer={() => document.body}
            onCancel={() => hideCodeModal()}
            open={props.visible}
            width={338}
            wrapClassName="code-modal-wrap"
            zIndex={1100}
        >
            <div className="code-box">
                <div className="code-title">{title}</div>
                {notice && <div className="code-notice">{notice}</div>}
                {codeErr && <div className="code-notice">{codeErr}</div>}
                <div className="code-form">
                    <div className="code-inputWrap">
                        <input
                            autoFocus
                            onChange={(e) => handleCodeChange(e)}
                            placeholder={inputPlaceholder}
                            value={codeInput}
                        />
                    </div>
                    <div className="code-imageRow">
                        <div className="code-imageWrap">
                            <img alt="" onClick={() => refreshCode()} src={imgCode} />
                        </div>
                        <div className="code-refreshText" onClick={() => refreshCode()}>
                            看不清？换一张
                        </div>
                    </div>
                </div>
                <div className="button" onClick={() => validateCode()}>
                    {confirmText}
                </div>
            </div>
        </Modal>
    );
}

export default CodeModal;
